<div class="copo-container" *ngIf="!isLoading">
	<div class="copo-section">
		<div class="copo-section-header">
			<span translate>fastlane.wizard.header.request.data</span>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column width-content" *ngIf="form.getFormCustomerRequestName().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.header.wizard.customer-request-name
					</div>
					<div class="card-content-value width-content "
						[matTooltip]="form.getFormCustomerRequestName().value ?getTooltipDescriptionText(form.getFormCustomerRequestName().value) : UNDERSCORE">
						{{ requestName ? requestName : UNDERSCORE }}
					</div>
				</div>
			</div>
			<div class="copo-grid-row-column width-content">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.soldto.name</div>
					<div class="card-content-value width-content" [matTooltip]="soldto ? soldto : UNDERSCORE">
						{{ soldto ? soldto : UNDERSCORE }} </div>
				</div>
			</div>
			<div class="copo-grid-row-column width-content" *ngIf="form.getFormDescription().value">
				<div class="card-content-info">
					<div class="card-content-label" translate>fastlane.wizard.header.global.description</div>
					<div class="card-content-value width-content" matTooltipClass="multiline-tooltip" TextWrapping="Wrap"
						[matTooltip]="form.getFormDescription().value ? getTooltipDescriptionText(form.getFormDescription().value): UNDERSCORE">
						{{ description }}</div>
				</div>
			</div>
			<div class="copo-grid-row-column" *ngIf="!form.getFormDescription().value">
			</div>
		</div>
		<div class="copo-section-body copo-grid">
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
					<div class="card-content-info">
						<div class="card-content-label" translate>fastlane.wizard.shipto.name</div>
						<div class="card-content-value" [matTooltip]="shipto ? shipto : UNDERSCORE">
							{{ shipto ? shipto : UNDERSCORE }}
						</div>
					</div>
				</div>
				<div *ngIf="customDestination" class="copo-grid-row-column width-content">
					<div class="card-content-info">
						<div class="card-content-label" translate>fastlane.wizard.custom.destination</div>
						<div class="card-content-value width-content" matTooltipClass="multiline-tooltip" [matTooltip]="getCustomShipToTooltipText()">
							{{ customDestination }}
						</div>
					</div>
				</div>
				<div *ngIf="!customDestination" class="copo-grid-row-column width-content">
				</div>
				<div class="copo-grid-row-column">
					<div class="copo-attachment-block">
						<div *ngIf="hasRequestAttachments()" class="card-content-label" translate>
							claim.attachments</div>
						<div class="card-content-value" *ngFor="let attachment of getRequestAttachments();">
							<a class="attachment-link" [href]="attachment.localUrl | copoSafeUrl" target="_blank">{{attachment.fileName}}</a></div>
					</div>
				</div>
			</div>
		</div>
		<div class="copo-section-body copo-grid">
			<div class="copo-grid-row">
				<div class="copo-grid-row-column" *ngIf="form.getFormCurrency().value">
					<div class="card-content-info">
						<div class="card-content-label" translate>fastlane.wizard.currency</div>
						<div class="card-content-value"
							[matTooltip]="form.getFormCurrency().value ? form.getFormCurrency().value : UNDERSCORE">
							{{ currency ? currency : UNDERSCORE }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="!isLoading">
	<div class="copo-container fastlane-grey-block line-space">
		<div class="copo-section">
			<div class="copo-section-header">
				<div class="card-header-left">
					<div class="card-title-label">
						<span translate>fastlane.wizard.items.details.itemrequest</span>
					</div>
				</div>
				<div class="card-header-middle file-import-row-1">
					<div class="file-import-note">
						<span translate>fastlane.file.import.note</span>
					</div>
					<div>
						<button type="button" mat-button class="file-import-button" (click)="openFileImportDialog()"><span translate>fastlane.file.import.button</span> <mat-icon iconPositionEnd class="batch-icon" svgIcon="icon-upload"></mat-icon></button>
					</div>
					<div class="file-import-note">
						<span translate>fastlane.file.template.download.note</span>:
						<a [href]="downloadTemplate() | copoSafeUrl" translate>
							fastlane.xlx.template
						</a>
					</div>
				</div>
				<div class="card-header-right">
					<button mat-button type="button" (click)="addItem()" tabindex="-1" copoFocusMe>
						<span class="add-product" translate>fastlane.wizard.items.details.addanitem</span>
						<mat-icon iconPositionEnd class="plus-icon plus-icon-size" matSuffix svgIcon="plus_button"></mat-icon>
					</button>
				</div>
			</div>
			<div class="copo-section-header file-import-row-2">
				<div class="card-header-middle">
					<div class="file-import-note">
						<span translate>fastlane.file.import.note</span> <button type="button" mat-button class="file-import-button" (click)="openFileImportDialog()"><span translate>fastlane.file.import.button</span> <mat-icon iconPositionEnd class="batch-icon" svgIcon="icon-upload"></mat-icon></button>
					</div>
					<div class="file-import-note">
						<span translate>fastlane.file.template.download.note</span>:
						<a [href]="downloadTemplate() | copoSafeUrl" translate>
							fastlane.xlx.template
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="copo-container">
	<div class="copo-section" *ngIf="!checkItemList()">
		<div class="copo-section-header-fastlane">
			<div class="copo-grid-row">
				<div class="copo-grid-row-column">
				</div>
				<div class="copo-grid-row-column">
					<span translate>fastlane.wizard.header.no.item.list</span>
				</div>
				<div class="copo-grid-row-column">
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #loading>
	<copo-loading-spinner *ngIf="isLoading"></copo-loading-spinner>
</ng-template>
<div *ngIf="checkItemList() && !isLoading else loading" class="copo-container fastlane-product-block">
	<div class="copo-section">
		<form [formGroup]="productFormGroup" novalidate autocomplete="off">
			<div class="grid-column-one-full card-block">
				<div formArrayName="productSpecifications">
					<div class="card-product-block" *ngFor="let itemrow of productResultControl; let i=index"
						[formGroupName]="i" #rows>
						<div class="copo-dark-theme copo-dark-theme-padding column-11"
							[ngClass]="[getExpandPanelStatus(i) ? 'card-header-top-rounded':'card-header-rounded', isSheetSelected(i) ? 'column-11' : 'column-10']">
							<div class="card-container-column step-product-spec-field field-padding">
								<div class="card-header-label field-width" translate>
									fastlane.itemlist.product.item_number</div>
								<div class="card-header-label field-width"> {{ i+1 | number: '3.' }}</div>
							</div>
							<mat-form-field subscriptSizing="dynamic" class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label class="card-header-label field-width"
									translate>fastlane.itemlist.product.item_name</mat-label>
								<input matInput type="text" maxlength="80" class="input-field-text field-width"
									formControlName="name" (change)="spaceHandle(i, 'name')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"
									matSuffix></mat-icon>
								<mat-hint>{{getItemNameLength(i) || 0}}/80</mat-hint>
								<mat-error
									[matTooltip]="('fastlane.itemlist.product.item_name.error' | translate)">
									<span translate>fastlane.itemlist.product.item_name.error</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label
									translate>fastlane.itemlist.product.steel_grade</mat-label>
								<input matInput type="text" maxlength="255" class="input-field-text field-width"
									formControlName="steelgrade" (change)="spaceHandle(i, 'steelgrade')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"
									matSuffix></mat-icon>
								<mat-hint>{{ getSteelGradeLength(i) || 0}}/255</mat-hint>
								<mat-error
									[matTooltip]="('fastlane.itemlist.product.steel_grade.error' | translate)">
									<span translate>fastlane.itemlist.product.steel_grade.error</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label
									translate>fastlane.itemlist.product.item_form</mat-label>
								<mat-select class="steel-grade-text-color" formControlName="form"
									[value]="getOrderTrackingForm(i)"
									(selectionChange)="onOrderTrackingFormChange(i, $event.value)">
									<mat-option *ngFor="let index of getFormValues()|copoSortOptions:true: config" [value]="index.value">										
										{{ index.display }}
									</mat-option>
								</mat-select>
								<mat-error
									[matTooltip]="('fastlane.itemlist.product.item_form.error' | translate)">
									<span translate>fastlane.itemlist.product.item_form.error</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label
									translate>fastlane.itemlist.order.thickness</mat-label>
								<input matInput class="input-field-text field-width" type="number"
									copoInputNumber 
									formControlName="thickness" [min]="0" [max]="999" [decimalCount]="3" step="0.01"
									[formControl]="getControl(i, 'thickness')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"
									matSuffix></mat-icon>
								<mat-error *ngIf="isThicknessEmpty(i)"
									[matTooltip]="('fastlane.itemlist.product.thickness.error' | translate)">
									<span translate>fastlane.itemlist.product.thickness.error</span>
								</mat-error>
								<mat-error *ngIf="!isThicknessEmpty(i)"
									[matTooltip]="('fastlane.itemlist.product.thickness.error.invalid' | translate)">
									<span translate>fastlane.itemlist.product.thickness.error.invalid</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" *ngIf="isSelectedAndNotFormBlanks(i)"
								class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label translate>order.width</mat-label>
								<input matInput class="input-field-text field-width" type="number"
									formControlName="width" copoInputNumber [min]="1" [decimalCount]="0"
									[max]="999999999" [formControl]="getControl(i, 'width')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"
									matSuffix></mat-icon>
								<mat-error
									[matTooltip]="('fastlane.itemlist.product.width.error' | translate)">
									<span translate>fastlane.itemlist.product.width.error</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" *ngIf="isSheetSelected(i)"
								class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label translate>batch.length</mat-label>
								<input matInput class="input-field-text field-width" type="number"
									formControlName="length" copoInputNumber [min]="1" [decimalCount]="0"
									[max]="999999999" [formControl]="getControl(i, 'length')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"
									matSuffix></mat-icon>
								<mat-error
									[matTooltip]="('fastlane.itemlist.product.length.error' | translate)">
									<span translate>fastlane.itemlist.product.length.error</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" *ngIf="isFormBlankSelected(i)"
								class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label
									translate>fastlane.itemlist.product.blank_weight</mat-label>
								<input matInput class="input-field-text field-width" type="number"
									formControlName="blankWeight" copoInputNumber [min]="1" [decimalCount]="3"
									[max]="99999999" [formControl]="getControl(i, 'blankWeight')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"
									matSuffix></mat-icon>
								<mat-error
									[matTooltip]="('fastlane.itemlist.product.blank_weight.error' | translate)">
									<span translate>fastlane.itemlist.product.blank_weight.error</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label
									translate>fastlane.itemlist.global.quantity</mat-label>
								<input matInput class="input-field-text field-width" type="number"
									formControlName="quantity" copoInputNumber [min]="1" [max]="99999999"
									[decimalCount]="getDecimalPoinforQuantity(i)"
									[formControl]="getControl(i, 'quantity')">
								<mat-icon class="pencil-icon pencil-icon-white" svgIcon="copo_pencil"
									matSuffix></mat-icon>
								<mat-error
									[matTooltip]="('fastlane.itemlist.global.quantity.error' | translate)">
									<span translate>fastlane.itemlist.global.quantity.error</span>
								</mat-error>
							</mat-form-field>
							<mat-form-field subscriptSizing="dynamic" class="card-container-column step-product-spec-field field-padding"
								floatLabel="always">
								<mat-label
									translate>fastlane.itemlist.global.unit</mat-label>
								<mat-select class="steel-grade-text-color" formControlName="quantityUnit"
									(selectionChange)="updateQuantityField(i)" [value]="getUnit(i)">
									<mat-option *ngFor="let index of getUnitList(i)| copoSortOptions:true:config" [value]="index.value">
										{{ index.display }}
									</mat-option>
								</mat-select>
								<mat-error
									[matTooltip]="('fastlane.itemlist.global.unit.error' | translate)">
									<span translate>fastlane.itemlist.global.unit.error</span>
								</mat-error>
							</mat-form-field>

							<div class="card-header-right">
								<div>
									<button type="button" mat-icon-button [matMenuTriggerFor]="menu">
										<mat-icon svgIcon="md:more_vert"></mat-icon>
									</button>
									<mat-menu #menu="matMenu" xPosition="before" yPosition="below">
										<button type="button" mat-menu-item (click)="resetProduct(i)"><span
												translate>need4steel.wizard.stepper.product.action.reset</span>
										</button>
										<button type="button" mat-menu-item [disabled]="disableDeleteMenu()" (click)="removeProductResult(i)"><span
												translate>need4steel.wizard.stepper.product.action.delete</span>
										</button>
										<button type="button" mat-menu-item [disabled]="disableDuplicateMenu()" (click)="duplicateProduct(i)"><span
												translate>need4steel.wizard.stepper.product.action.duplicate</span>
										</button>
									</mat-menu>
								</div>
								<div>
									<button type="button" mat-icon-button (click)="expandPanel(i)">
										<mat-icon [ngClass]="(getExpandPanelStatus(i))?'':'drop-down-rotate'"
											svgIcon="md:drop_down"></mat-icon>
									</button>
								</div>
							</div>
						</div>
						<mat-expansion-panel class="product-section" [expanded]="isExpanded[i]">
							<ng-template matExpansionPanelContent>
								<div class="copo-grid-row">
									<div class="card-content-left">
										<mat-form-field subscriptSizing="dynamic"
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()" floatLabel="always" >
											<mat-label class="card-content-label-1" translate>order.coating</mat-label>
											<input matInput type="text" maxlength="50"
												class="input-field-text field-width" formControlName="coating"
												(change)="spaceHandle(i, 'coating')">
											<mat-icon class="pencil-icon pencil-icon-grey" svgIcon="copo_pencil"
												matSuffix></mat-icon>
											<mat-error
												[matTooltip]="('fastlane.itemlist.product.coating.mandatory' | translate)">
												<span translate>fastlane.itemlist.product.coating.mandatory</span>
											</mat-error>
										</mat-form-field>
										<mat-form-field subscriptSizing="dynamic" *ngIf="isCoilOrSlittingCoilSelected(i)"
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()" floatLabel="always"	>
											<mat-label class="card-content-label-1"
												translate>fastlane.itemlist.product.coil_axis</mat-label>

											<mat-select formControlName="coilAxis"
												[value]="getCoilAxis(i)">
												<mat-option *ngFor="let index of getCoilList() | copoSortOptions:true: config" [value]="index.value">
													{{ index.display }}
												</mat-option>
											</mat-select>
										</mat-form-field>
										<mat-form-field subscriptSizing="dynamic"
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()" floatLabel="always">
											<mat-label class="card-content-label-1"
												translate>fastlane.itemlist.productcharacteristic.oilquantity</mat-label>
											<input matInput type="text" maxlength="50"
												class="input-field-text field-width" formControlName="oiling"
												(change)="spaceHandle(i, 'oiling')">
											<mat-icon class="pencil-icon pencil-icon-grey" svgIcon="copo_pencil"
												matSuffix></mat-icon>
										</mat-form-field>

										<mat-form-field subscriptSizing="dynamic" *ngIf="isCoilOrSlittingCoilSelected(i)"
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()" floatLabel="always"	>
											<mat-label class="card-content-label-1"
												translate>fastlane.itemlist.coil.inner.diameter</mat-label>
											<mat-select formControlName="innerDiameter"
												[value]="getCoilInnerDiameter(i)">
												<mat-option *ngFor="let index of getInnerDiameterList() | copoSortOptions:true: config"
													[value]="index.value">
													{{ index.display }}
												</mat-option></mat-select>
										</mat-form-field>
										<mat-form-field subscriptSizing="dynamic" *ngIf="isCoilOrSlittingCoilSelected(i)"
											class="copo-content-product card-header-double-span copo-form-field label-padding" (click)="$event.stopPropagation()" floatLabel="always"	>
											<mat-label class="card-content-label-1"
												translate>fastlane.itemlist.coil.max_outer_diameter</mat-label>
											<input matInput class="input-field-text field-width" type="number"
												formControlName="maxOutsideDiameter" copoInputNumber [min]="1"
												[decimalCount]="0" [formControl]="getControl(i, 'maxOutsideDiameter')"
												[max]="999999999">
											<mat-icon class="pencil-icon pencil-icon-grey" svgIcon="copo_pencil"
												matSuffix></mat-icon>
										</mat-form-field>
									</div>
								</div>
								<div class="copo-grid-row card-content-total column-2">
										<div class="copo-content-product card-header-double-span copo-form-field label-padding">
										<div class="card-content-label" translate>
											fastlane.wizard.items.details.total.weight</div>
										<div class="card-content-value">
											{{calculateTotalWeight(i) | copoNumber:'amount':''}}</div>
									</div>
										<div *ngIf="isSheetSelected(i) && isSheetWeight(i)" class="copo-content-product card-header-double-span copo-form-field label-padding">
										<div class="card-content-label" translate>
											fastlane.wizard.items.details.sheet.weight</div>
										<div class="card-content-value">
											{{calculateSheetWeight(i) | copoNumber:'amount':''}}</div>
									</div>
								</div>
								<div class="copo-stepper-container copo-form-container">
									<div class="copo-grid-row-file-upload copo-grid-row-stretch">
										<div class="copo-grid-row-2-columns">
											<div class="copo-label copo-outline-label" translate><span class=""></span> &nbsp;</div>
											<mat-form-field subscriptSizing="dynamic" class="outline-comment" appearance="outline">
												<mat-label translate>fastlane.itemlist.item.additional.info</mat-label>
												<textarea rows="3" matInput maxlength="255" class="textarea-no-resize"
												cdkTextareaAutosize
												 formControlName="additionalItemInfo">
												</textarea>
												<mat-hint>{{ getAdditionalInfoLength(i) || 0}}/255</mat-hint>
											</mat-form-field>
										</div>
										<div class="copo-grid-row-2-columns">
											<div class="copo-label copo-outline-label" translate>claim.attach.several.documents<span class="asterick"></span></div>
											<copo-file-upload
												class="file-upload"
												#attachmentDiv
												[files]="files(i)"
												[fileErrors]="fileErrors(i)"
												[dragAndDropLabel]="('drag.and.drop.files' | translate)"
												[orLabel]="('upload.or' | translate)"
												[browseFilesLabel]="('browse.files' | translate)"
												[fileUploadNote]="('attachment.limit.description' | translate)"
												(filesAdded)="addAttachments($event, i)"
												(fileRemoved)="removeAttachmentEvent($event, i)">
											</copo-file-upload>
										</div>
									</div>
								</div>
							</ng-template>
						</mat-expansion-panel>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>